import React from "react";

// Vertical bar chart, pure CSS. data: [{label, value, color}]
export function VBars({ data, height = 220, unit = "" }) {
  const max = Math.max(1, ...data.map((d) => d.value));
  return (
    <div className="w-full" style={{ height }}>
      <div className="flex items-end gap-2 h-[calc(100%-28px)]">
        {data.map((d, i) => (
          <div key={i} className="flex-1 flex flex-col items-center justify-end h-full group">
            <span className="font-mono text-[10px] t-muted mb-1 opacity-0 group-hover:opacity-100 transition-opacity">{d.value}{unit}</span>
            <div className="w-full rounded-t-[3px] transition-all duration-300"
              style={{ height: `${(d.value / max) * 100}%`, background: d.color || "#33559d", minHeight: d.value > 0 ? 4 : 0 }} />
          </div>
        ))}
      </div>
      <div className="flex gap-2 mt-2">
        {data.map((d, i) => (
          <div key={i} className="flex-1 text-center font-mono text-[9px] t-faint leading-tight" style={{ transform: "rotate(-18deg)", transformOrigin: "center" }}>{d.label}</div>
        ))}
      </div>
    </div>
  );
}

// Horizontal bar with reference marker at 100. data: [{label, value, color}]
export function HBars({ data, refValue = 100, maxValue = 130 }) {
  return (
    <div className="space-y-3">
      {data.map((d, i) => (
        <div key={i} className="flex items-center gap-3">
          <div className="w-28 shrink-0 text-sm t-body truncate">{d.label}</div>
          <div className="flex-1 h-6 bg-[#eef1f5] rounded-[3px] relative overflow-hidden">
            <div className="h-full rounded-[3px] transition-all duration-500" style={{ width: `${Math.min(100, (d.value / maxValue) * 100)}%`, background: d.color }} />
            <div className="absolute top-0 bottom-0" style={{ left: `${(refValue / maxValue) * 100}%`, borderLeft: "2px dashed #868686" }} />
          </div>
          <div className="w-12 text-right font-mono text-sm font-600" style={{ color: d.color }}>{d.value}%</div>
        </div>
      ))}
    </div>
  );
}
